import img1 from "../img/ServiceItem/ServieItem1.jpg";
import img2 from "../img/ServiceItem/ServieItem2.jpg";
import img3 from "../img/ServiceItem/ServieItem3.jpg";

const ServiceItems = [

    {
        headerText: "團隊服務項目", list: [".NET C# MVC / Node.JS Web 架構 開發",
            "HTML5/CSS3/Java Script 前端開發", "支援 BootStrap/React/Vue 前端框架",
            "Oracle/SQL Server/MySQL 資料庫設計", "Android APP 開發", "系統規劃與建置"],
        Imgsrc: img1,
        Link:'',
        AnchorPosition:""
    },

    {
        headerText: "行動開發經驗",
        list: [`Android PDA，我們提供客戶使用Android PDA軟體，用於管理連鎖超市 門市管理，新鮮蔬果、魚肉採購，食品工廠倉庫入出庫管理。`],
        Imgsrc:img2,
        Link:'/HomeSuccessCase',
        AnchorPosition:"All"
    },

    {
        headerText: "系統服務團隊", list: ["我們組建專業服務團隊，由專案經理，軟體工程師，測試工程師，部屬及線上服務人員所組成。提供即時及正確的服務內容，滿足客戶需求。"],
        Imgsrc: img3,
        Link:'/DetailLook',
    }

];

export default ServiceItems;
